export default [
  { text: 'Наименование', value: 'name' },
  { text: 'Версия', value: 'version[0].version' },
  { text: 'Дата изменения', value: 'updated_at' },
  { text: '', value: 'actions', align: 'right', width: '75px' },
]
